import { z } from 'zod';

import { languageEnumValidator } from '../../validators';

const TranslationsSchema = z.record(
  languageEnumValidator,
  z.string().min(1, 'Translation cannot be empty'),
);

export const GenerateStoryResponseSchema = z.object({
  text: z.string().min(1, 'Text cannot be empty'),
  translations: TranslationsSchema,
});

export type IGenerateStoryResponseDto = z.infer<
  typeof GenerateStoryResponseSchema
>;
